module.exports = __webpack_public_path__ + "media/images/gradient-blue-background-2-0cad22d5dc3b773b94f678d933042ac9.jpg";